import {
  FormControl,
  FormHelperText,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  InputAdornment,
  ListSubheader,
} from '@material-ui/core';
import SearchIcon from '@mui/icons-material/Search';
import React, { useState } from 'react';
import { createIdFromLabel, generateRandomId } from '../../../utils/commonUtils';
import { handleValidation } from '../../../utils/formUtils';
import { ITEM_HEIGHT, ITEM_PADDING_TOP } from '../../../utils/Constants';

const CustomSelect = (props) => {
  const {
    item,
    isSearchable = false,
    handleInputChange,
    options,
    labelField,
    valueField,
    hideNullOption,
    nullOptionLabel,
    labelPrefix,
    disabled,
    shouldAppendCode,
    addCodeToEnd,
    className,
    bold = false,
    customStyle = false,
    isRequired = false,
    searchPlaceholder,
  } = props;

  const [searchText, setSearchText] = useState('');
  const searchResult = options?.filter((option) =>
    option[labelField || 'name']?.toLowerCase()?.includes(searchText?.toLowerCase()),
  );
  const fieldId = item.fieldName ? createIdFromLabel(item.fieldName) : generateRandomId();

  const getErrorMessage = () => {
    const errorMsgs = [];
    item?.validations?.forEach((validation) => {
      if (item.errors[validation]) {
        errorMsgs.push(item.errors[validation]);
      }
    });
    return errorMsgs.length > 0 ? errorMsgs[0] : null;
  };

  const onChange = (e) => {
    const inputValue = e.target.value;
    setSearchText('');
    const currField = { ...item };
    currField.value = inputValue;
    handleValidation(currField);
    handleInputChange(currField);
  };

  return (
    <FormControl
      className={`${className ?? 'w-100'} ${bold ? 'bold-option' : ''}`}
      required={isRequired ? isRequired : item.validations && item.validations.includes('required')}
      error={getErrorMessage() ? true : false}
    >
      <InputLabel id={fieldId + '_label'}>
        {labelPrefix} {item.fieldName}
      </InputLabel>
      <Select
        disabled={disabled}
        labelId={fieldId + '_label'}
        id={fieldId + '_select'}
        autoWidth={false}
        value={item?.value ?? ''}
        onChange={(e) => {
          onChange(e);
        }}
        onClose={() => setSearchText('')}
        MenuProps={{
          PaperProps: {
            style: {
              maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
              width: 160,
            },
          },
          getContentAnchorEl: null,
          anchorOrigin: {
            vertical: 'bottom',
            horizontal: 'center',
          },
          transformOrigin: {
            vertical: 'top',
            horizontal: 'center',
          },
          autoFocus: isSearchable ? false : true,
        }}
      >
        {isSearchable && (
          <ListSubheader className='custom-search-text'>
            <TextField
              value={searchText}
              autoFocus
              fullWidth
              placeholder={searchPlaceholder}
              onChange={(e) => setSearchText(e?.target?.value)}
              className='custom-search-input'
              InputProps={{
                endAdornment: (
                  <InputAdornment position='end'>
                    <SearchIcon />
                  </InputAdornment>
                ),
              }}
              onKeyDown={(e) => {
                if (e.key !== 'Escape') {
                  e.stopPropagation();
                }
              }}
              onClick={(e) => {
                e.stopPropagation();
              }}
            />
          </ListSubheader>
        )}
        {!hideNullOption && (
          <MenuItem value=''>
            <em>{nullOptionLabel || 'None'}</em>
          </MenuItem>
        )}

        {(isSearchable ? searchResult : options)?.map((item, key) => {
          return typeof item === 'object' ? (
            <MenuItem
              key={key}
              value={item[valueField || 'id']}
              className={`${customStyle ? item.styleVal : ''} ${bold ? 'bold-option' : ''}`}
            >
              {item['url'] && (
                <img
                  style={{ width: '20px', height: '20px' }}
                  className='mx-2'
                  src={item['url']}
                  alt={item['name']}
                />
              )}{' '}
              {shouldAppendCode && !addCodeToEnd && item['code'] ? `${item['code']} --- ` : ''}
              {item[labelField || 'name']}
              {shouldAppendCode && addCodeToEnd && item['code'] ? ` --- ${item['code']}  ` : ''}
            </MenuItem>
          ) : (
            <MenuItem key={key} value={item}>
              {item}
            </MenuItem>
          );
        })}
      </Select>
      <FormHelperText>{getErrorMessage()}</FormHelperText>
      <style>{`.bold-option {font-weight: bold;}`}</style>
    </FormControl>
  );
};

export default CustomSelect;
